export const tables = {
  all: 'all',
  accepted: 'accepted',
  denied: 'denied',
  sent: 'sent',
  left: 'left',
}
